export function validateFileSize(file: File, maxSizeInMB: number) {
  return file.size <= maxSizeInMB * 1024 * 1024
}
